/**
 * Kategori işlemleri için yardımcı fonksiyonlar
 */

/**
 * Kategori ID'sini normalleştirir - tutarlı tip sağlar
 *
 * @param {any} id - Herhangi bir tipte kategori ID'si
 * @returns {number} - Normalleştirilmiş sayısal ID
 */
export const normalizeCategoryId = (id) => {
  if (id === null || id === undefined) return 0
  const parsed = parseInt(id)
  return isNaN(parsed) ? 0 : parsed
}

/**
 * İki kategori ID'sinin eşleşip eşleşmediğini kontrol eder
 *
 * @param {any} id1 - İlk kategori ID'si
 * @param {any} id2 - İkinci kategori ID'si
 * @returns {boolean} - ID'ler eşleşiyorsa true
 */
export const isCategoryIdMatch = (id1, id2) => {
  return String(id1) === String(id2)
}

/**
 * Bir kategori ID'sinin listede olup olmadığını kontrol eder
 *
 * @param {Array} categoryList - Kategori ID'leri listesi
 * @param {any} categoryId - Kontrol edilecek kategori ID'si
 * @returns {boolean} - ID listede varsa true
 */
export const isCategoryInList = (categoryList, categoryId) => {
  if (!Array.isArray(categoryList) || categoryList.length === 0) return false
  return categoryList.some(id => String(id) === String(categoryId))
}